// Open tab when clicked in sidebar on lectures 
jQuery(document).ready(function($) {
    'use strict';
    $(window).on('hashchange', function(e) {
        e.preventDefault();
        var hash = document.location.hash;
        if(hash.substr(0, 1) !== '#') {
            hash = '#' + hash;
        }
        $(hash + ' .tab-headline').click();
    });
});